import { GET } from '@/helpers';
import { StrapiContacts, StrapiResponse } from '@/types';

export class ContactsApi {
  private CONTACTS_BACKEND_API: string;
  constructor() {
    this.CONTACTS_BACKEND_API = process.env.NEXT_PUBLIC_API_URL + '/kontakty'!;
  }

  async getContacts(): Promise<StrapiResponse<StrapiContacts> | { error: string }> {
    return GET(this.CONTACTS_BACKEND_API);
  }

  async getSocial(): Promise<StrapiResponse<StrapiContacts> | { error: string }> {
    return GET(this.CONTACTS_BACKEND_API + '?populate=*');
  }
}
